module.exports = __webpack_public_path__ + "static/project-16c-3dcee6fdb7c29b89963ac28d5572bd00.png";